import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Participantes, Person } from '../../models/participantes.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { ActivatedRoute } from '@angular/router';
import { ParticipantesService } from '../../services/participantes.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ParticipantesCombosResolver, ParticipantesResolverId } from '../../resolver/participantes.resolver';

@Component({
  selector: 'app-participantes-edit',
  templateUrl: './participantes-edit.component.html',
  styleUrls: ['./participantes-edit.component.scss']
})
export class ParticipantesEditComponent extends BaseFormComponent<Participantes> implements OnInit {
    actionLabel: string = 'Novo';
    filters:any;
    @Input() id:number;
    @Input() data:Person = null;
    @Input() type:string;
    @Output() closeModal = new EventEmitter<void>();
    @Output() excluir = new EventEmitter<void>();
    @Output() salvar = new EventEmitter<void>();
  constructor(
    public activatedRoute: ActivatedRoute,
    public myService: ParticipantesService,
    public participantesResolverId: ParticipantesResolverId,
    public participantesCombosResolver: ParticipantesCombosResolver,
  ) { 
    super(activatedRoute);
  }

  ngOnInit() {
    this.loading();
    this.initForm();
    this.start();
  }
  
  initForm() {
    if (this.type == 'participant'){
      this.form = new FormGroup({
        user_cpf: new FormControl(null,[Validators.required]),
      });
    }
    else{
      this.form = new FormGroup({
        id: new FormControl(null),
        name: new FormControl('', [Validators.required]),
        agency_id: new FormControl(null),
        fone: new FormControl(null),
        email: new FormControl(null, [Validators.email]),
        role_txt: new FormControl(null),
      });
    }
    if (this.data) {
      this.actionLabel = 'Editar';
      this.form.patchValue(this.data);
    }
  }
    
  start(){
    this.participantesCombosResolver.resolve(this.id == 0? null:this.id).subscribe({
      next: (filters) => {
        this.filters = filters;
        this.loaded();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error.error);
      }
    } );
  }
  
  getDataCreate() {
    return Object.assign({}, this.form.value);
  }

  onCloseModal(){
    this.closeModal.emit();
  }
  onSalvar(){
    if (this.form.valid) {
      var data = this.getDataCreate()
      if(this.type == 'participant'){
        var person = this.filters.personList.find(p => p.id == data.user_cpf);
        person.user_cpf = person?.id;
      }
      else{
        var agencyName = this.filters.agency.find(p => p.id == data?.agency_id);
        var person = {...data, agency_name: agencyName?.label};
      }
      this.salvar.emit(person);
    }
    else {
      this.markAsDirty();
    }
  }
  onExcluir(){
    this.excluir.emit();
  }

  maskPhone(event) {
    let newVal = event.target.value.replace(/\D/g, '');
    if (newVal.length === 0) {
      newVal = '';
    } else if (newVal.length <= 2) {
      newVal = newVal.replace(/^(\d{0,2})/, '($1)');
    } else if (newVal.length <= 6) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,4})/, '($1) $2');
    } else if (newVal.length <= 10) {
      newVal = newVal.replace(/^(\d{0,2})(\d{0,4})(\d{0,4})/, '($1) $2-$3');
    } else {
      newVal = newVal.substring(0, 11);
      newVal = newVal.replace(/^(\d{0,2})(\d{0,5})(\d{0,4})/, '($1) $2-$3');
    }
    this.form.get('fone').setValue(newVal);
    
  }

}
